<script>
import Modal from '../../Modal.vue'

export default {
    components: {
        Modal,
    },

    props: {
        jobApplication: {
            type: Object,
            required: true
        },
        csrfToken: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            currentUrl: window.location.href,
            exportAbleStages: [
                {
                    key: 'killer_question',
                    title: "Killer Questions"
                },
                {
                    key: 'language_proficiency',
                    title: "Language Proficiency"
                },
                {
                    key: 'telephonic_screening',
                    title: "Telephonic Screening"
                },
                {
                    key: 'first_interview',
                    title: "First Interview"
                },
                {
                    key: 'skill_assessment',
                    title: "Skills Assesment"
                },
            ]
        }
    },
    methods: {
        toggleModal() {
            this.$refs.modal.toggle()
        }
    }
}
</script>

<template>
    <modal ref="modal" heading="Recruiter Notes">
        <h4>Export Stage For {{ jobApplication.user.full_name }}</h4>
        <form method="POST"
            action="/recruiter/active-requisitions/export-stage">
            <input type="hidden" name="_csrfToken" :value="csrfToken" />
            <input type="hidden" name="job_application_id" :value="jobApplication.id" />
            <input type="hidden" name="redirect_url" :value="currentUrl" />
            <div class="grid-x grid-padding-x align-right">
                <div class="cell medium-12">
                    <label>Exportable Stages:</label>
                    <br/>
                    <div class="export-stage-checkbox-group">
                        <label class="export-stage-checkbox-inline" v-for="exportAbleStage in exportAbleStages" :key="exportAbleStage.key">
                            <input :disabled="(jobApplication[exportAbleStage.key + '_status'] !== 'passed')" type="checkbox" name="stages[]" :value="exportAbleStage.key"> {{ exportAbleStage.title }}
                        </label>
                    </div>
                </div>
                <div class="cell medium-12">
                    *) Incompleted stage can't be exported
                </div>
            </div>

            <div class="grid-x grid-padding-x align-right">
                <div class="cell shrink">
                    <button class="button" :disabled="(jobApplication.recruiter_notes === '')" type="submit">Download</button>
                </div>

                <div class="cell shrink">
                    <button @click="toggleModal" class="button warning" type="button">Close</button>
                </div>
            </div>
        </form>
    </modal>
</template>

<style>
.export-stage-checkbox-group {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 10px;
}

.export-stage-checkbox-inline {
    display: inline-flex;
    align-items: center;
    margin-right: 10px;
    margin-bottom: 5px;
}

.export-stage-checkbox-inline input[type="checkbox"] {
    vertical-align: middle;
    margin-right: 5px;
}
</style>
